import { Injectable } from '@angular/core';
import { RequestBase } from './request-base';
import { Observable } from 'rxjs';

@Injectable()
export class WorkerInfoService extends RequestBase {
    BasePath = 'api/workerinfo/';

    ReadWorker(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'ReadWorker', this.options);
    }

    GetWorkerLog(id: string): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetWorkerLog?id=' + id, this.options);
    }
}